export default "__VITE_ASSET__BRq6HXVy__"